<datalist id="{{appId}}">
    <ng-container>
      <option *ngFor="let season of seasons" value='{{season.code}}'>{{season.code}}</option>
    </ng-container>
</datalist>
  